import React from 'react'

function Index() {
	return (
		<div>AverageCheque</div>
	)
}

export default Index